import { render } from "./ScenarioTest.vue?vue&type=template&id=6267bef6&scoped=true&ts=true"
import script from "./ScenarioTest.vue?vue&type=script&lang=ts"
export * from "./ScenarioTest.vue?vue&type=script&lang=ts"

import "./ScenarioTest.vue?vue&type=style&index=0&id=6267bef6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6267bef6"]])

export default __exports__